"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecuteList = void 0;
const complex_data_1 = require("complex-data");
const complex_plugin_1 = require("complex-plugin");
const dictionary_1 = require("@/config/dictionary");
const layout_1 = __importDefault(require("@/config/utils/layout"));
const config_1 = require("@/config/dictionary/config");
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const select_1 = require("@/pages/index/select");
const dict_1 = require("@/pages/index/select/dict");
const litigation_2 = require("@/pages/index/select/litigation");
const operateLog_1 = require("@/pages/index/utils/operateLog");
class ExecuteList extends complex_data_1.ComplexList {
    // buildItem(postData: Record<string, unknown>, payload: { id: string }) {
    //   return new Promise((resolve, reject) => {
    //     postData.overdueRecordId = payload.id
    //     litigationApi.litigationExecuteBuild.require(postData).then(() => {
    //       notice.showMsg('法诉执行申请成功！', 'success')
    //       resolve({ status: 'success' })
    //     }).catch(err => {
    //       // eslint-disable-next-line no-console
    //       console.error(err)
    //       reject(err)
    //     })
    //   })
    // }
    changeItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            const currentStatus = originData.status.value;
            const next = litigation_2.executeStatus.getRelation(currentStatus, 1);
            postData.curTaskDefKey = currentStatus;
            if (next) {
                postData.nextTaskDefKey = next.value;
            }
            litigation_1.default.litigationExecuteChange.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('法诉执行申请审批成功！', 'success');
                if (next) {
                    (0, operateLog_1.pushOperateLog)(originData.litigationRecordId, '维护' + next.label, 'litigationRecord');
                }
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    rejectItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            const currentStatus = originData.status.value;
            const next = litigation_2.executeStatus.getRelation(currentStatus, 1);
            postData.curTaskDefKey = currentStatus;
            if (next) {
                postData.nextTaskDefKey = next.value;
            }
            litigation_1.default.litigationExecuteReject.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('法诉执行申请驳回完成！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    refuseItem(postData, payload, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            postData.taskId = payload.id;
            const currentStatus = originData.status.value;
            const next = litigation_2.executeStatus.getRelation(currentStatus, 1);
            postData.curTaskDefKey = currentStatus;
            if (next) {
                postData.nextTaskDefKey = next.value;
            }
            litigation_1.default.litigationExecuteRefuse.require(postData).then(() => {
                complex_plugin_1.notice.showMsg('法诉执行申请拒绝完成！', 'success');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.ExecuteList = ExecuteList;
const layoutParse = new layout_1.default(3, 9, 15);
const executeList = new ExecuteList({
    name: '执行申请',
    prop: 'executeList',
    module: {
        dictionary: {
            layout: {
                default: layoutParse.getData(3)
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'litigationRecordId',
                    name: '法诉记录ID',
                    originProp: 'litigationRecordId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'litigationStatus',
                    name: '无',
                    originProp: 'litigationStatus',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'code',
                    name: '申请编号',
                    originProp: 'code',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                },
                {
                    prop: 'applyUserId',
                    name: '无',
                    originProp: 'applyUserId',
                    originFrom: 'list',
                    mod: {}
                },
                (0, dictionary_1.buildDictionaryBySelect)(litigation_2.executeStatus, {
                    prop: 'status',
                    name: '执行状态',
                    originProp: 'taskDefKey',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(select_1.ApprovalStatus, {
                    prop: 'applyStatus',
                    name: '审批状态',
                    originProp: 'applyStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'passTime',
                    name: '无',
                    originProp: 'passTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'deploymentId',
                    name: '无',
                    originProp: 'deploymentId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'procInsId',
                    name: '无',
                    originProp: 'procInsId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'applyComment',
                    name: '无',
                    originProp: 'applyComment',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'taskId',
                    name: '无',
                    originProp: 'taskId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'freezeBeginTime',
                    name: '冻结时间',
                    originProp: 'freezeBeginTime',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            type: 'date',
                            required: true
                        },
                        ufo_cs_zx_40: {
                            $target: 'edit'
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.LitigationExecuteUnsealReason, {
                    prop: 'unsealReason',
                    name: '解除原因',
                    originProp: 'unsealReason',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            required: true
                        },
                        ufo_cs_zx_50: {
                            $target: 'edit'
                        }
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.LitigationExecuteUnsealContent, {
                    prop: 'unsealContent',
                    name: '解除内容',
                    originProp: 'unsealContent',
                    originFrom: 'list',
                    mod: {
                        edit: {
                            required: true
                        },
                        ufo_cs_zx_50: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'remark',
                    name: '无',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdBy',
                    name: '无',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdName',
                    name: '创建人',
                    originProp: 'createdName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'updatedBy',
                    name: '无',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '无',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'taskDefKey',
                    name: '当前审批节点',
                    originProp: 'taskDefKey',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'menu',
                    name: '操作',
                    originProp: 'menu',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(2)
                        }
                    }
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            litigation_1.default.litigationExecute.require(Object.assign(Object.assign({}, this.$getSearch()), { litigationRecordId: this.$getExtra('litigationRecordId'), pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = executeList;
